module.exports = __webpack_public_path__ + "img/user-b.f0019656.png";